module.exports = __webpack_public_path__ + "static/media/SolasSketchListMap.cae7934b.jpg";